import { UPDATELOGO_FAIL, UPDATELOGO_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateLogoReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATELOGO_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATELOGO_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateLogoReducer;
